import { render } from "./MultiQC.vue?vue&type=template&id=28d47b98&scoped=true"
import script from "./MultiQC.vue?vue&type=script&lang=js"
export * from "./MultiQC.vue?vue&type=script&lang=js"

import "./MultiQC.vue?vue&type=style&index=0&id=28d47b98&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d47b98"]])

export default __exports__